import React, { useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import { DatePicker } from 'components/Form/DatePicker';
import Text from 'components/Text';
import useTheme from 'hooks/useTheme';
import { ResponsiveCol, ResponsiveRow } from '../AddEvents/styles';
import { TicketDetail } from './Components/TicketDetail';
import { TicketMoreDetail } from './Components/TicketMoreDetail';

export const OtherTickets = ({
  handleChange,
  COLOR_CODES,
  ticket,
  index,
  ticketType,
  errors,
  allCategories,
  is_multiday,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

  // Set access code in parent component to true if code, code_date or code_time is set after the component is mounted
  useEffect(() => {
    if (ticket.code || ticket.code_date || ticket.code_time) {
      // Do it after a delay to avoid setting the access code to true before the component is mounted
      setTimeout(() => {
        handleChange({
          target: {
            name: `access_code`,
            value: true,
          },
        });
      }, 1000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <ResponsiveRow style={{ alignItems: 'center' }}>
        <Text
          style={{ marginRight: '15px' }}
          type="label"
          color={theme.colors.black}
          inlineStyle={{ textTransform: 'capitalize' }}
        >
          Other ticket
        </Text>
        <ResponsiveCol>
          <DatePicker
            name={`${ticketType}.${index}.start_date`}
            error={
              errors[`${ticketType}.${index}.start_date`]
                ? errors[`${ticketType}.${index}.start_date`]
                : ''
            }
            type="date"
            label=""
            value={ticket.start_date}
            onChange={(_, value) => {
              handleChange({ target: { name: 'start_date', value } });
              errors[`${ticketType}.${index}.start_date`] = '';
            }}
            isResponsive={true}
          />
        </ResponsiveCol>
        {/* Display end date only if event is multi day event */}
        <ResponsiveCol>
          {is_multiday && (
            <DatePicker
              name={`${ticketType}.${index}.end_date`}
              error={
                errors[`${ticketType}.${index}.end_date`]
                  ? errors[`${ticketType}.${index}.end_date`]
                  : ''
              }
              type="date"
              label=""
              value={ticket.end_date}
              onChange={(_, value) => {
                handleChange({ target: { name: 'end_date', value } });
                errors[`${ticketType}.${index}.end_date`] = '';
              }}
              isResponsive={true}
            />
          )}
        </ResponsiveCol>
      </ResponsiveRow>

      <TicketDetail
        ticketType={ticketType}
        index={index}
        ticket={ticket}
        handleChange={handleChange}
        errors={errors}
        allCategories={allCategories}
        isMobile={isMobile}
        COLOR_CODES={COLOR_CODES}
      />

      <TicketMoreDetail
        handleChange={handleChange}
        ticket={ticket}
        index={index}
        ticketType={ticketType}
        errors={errors}
        isMobile={isMobile}
      />
    </>
  );
};
